import React, { useEffect, useState } from 'react';

import classnames from 'classnames';

import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CloseIcon from '@material-ui/icons/Close';

import css from '../nibTable.module.sass';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const SelectCell = ({
  value: initialValue,
  row: { index },
  column: { id },
  rowToEdit,
  updateMyData,
  data,
  getAllCompaniesTypes,
  forceUpdateRow,
  ...props
}) => {
  const [value, setValue] = useState(initialValue);
  const [isError, setError] = useState(false);
  const oninit = [...value.map((val) => val.id)];
  const [selected, setSelected] = useState(oninit);

  const handleChange = (e) => {
    setSelected([...e.target.value]);
    updateMyData({ accessor: id, value: e.target.value });
  };

  const generateLabel = (selected) => {
    let names = data.filter((dt) => selected.includes(dt.id));
    let label = names.map((name) => name.name).join(', ');
    return label;
  };

  useEffect(() => {
    if (forceUpdateRow.index === index) {
      if (forceUpdateRow.hasOwnProperty(id)) {
        setSelected(forceUpdateRow[id].map((val) => val.id));
        setError(true);
      }
    }
  }, [forceUpdateRow]);

  useEffect(() => {
    if (isError) {
      setTimeout(function () {
        setError(false);
      }, 2000);
    }
  }, [isError]);

  if (rowToEdit.index === index && rowToEdit.status) {
    return (
      <div className={classnames(css.selectCell, isError && css.error)}>
        <IconButton onClick={() => handleChange({ target: { value: oninit } })}>
          <CloseIcon style={{ color: '#fff' }} />
        </IconButton>
        <Select
          className={css.selectCell}
          multiple
          value={selected}
          onChange={handleChange}
          input={<Input />}
          renderValue={generateLabel}
          MenuProps={MenuProps}
        >
          {data.map((val) => (
            <MenuItem key={val.id} value={val.id}>
              <Checkbox checked={selected.includes(val.id)} />
              <ListItemText primary={val.name} />
            </MenuItem>
          ))}
        </Select>
      </div>
    );
  } else {
    return <p className={classnames(isError && css.error)}>{generateLabel(selected)}</p>;
  }
};

export default SelectCell;
